module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/banner/banner-create/banner-create.component.scss
// module id = ./src/app/banner/banner-create/banner-create.component.scss
// module chunks = main